import { FC, PropsWithChildren } from 'react';
import { ContentContainer } from '@spikemark/ui/components/content-container';
type TournamentNavigationProps = PropsWithChildren;
export const TournamentNavigation: FC<TournamentNavigationProps> = ({
  children
}) => {
  return <div className="lg:-mx-2 bg-primary dark space-y-2 lg:space-y-0 lg:space-x-4 lg:divide-x divide-zinc-300 mb-[-1px] sticky top-header-mobile lg:top-header z-30 print:hidden" data-sentry-component="TournamentNavigation" data-sentry-source-file="navigation.tsx">
      <ContentContainer suppressVerticalMargin data-sentry-element="ContentContainer" data-sentry-source-file="navigation.tsx">{children}</ContentContainer>
    </div>;
};